<template>
  <div class="home">

    <!--
    <video playsinline autoplay muted loop poster='//media.polyphonyproject.com/media/frontend/headers/start-page/002/video.jpg'>
        <source src="//media.polyphonyproject.com/media/frontend/headers/start-page/002/video.webm" type="video/mp4">
        <source src="//media.polyphonyproject.com/media/frontend/headers/start-page/002/video.mp4" type="video/mp4">
    </video>
    -->
    <video-background 
        :src="videoSrc"
        :poster="videoPoster"
        :style="videoStyle"
    >
    </video-background>
    <div class="grey lighten-3 py-5" style="margin-top: -10px;">
      <v-container>
        <v-row>
          <v-col cols="12" md="6">
            <v-img
            src="/img/start_about.jpg"
            :height="300"
            contain
            ></v-img>
          </v-col>
          <v-col cols="12" md="6">
              <h1 class="display-1 mb-5">{{ $t('app.title') }}</h1>
              <p>{{ $t('content.intro_details') }}</p>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <v-container>
    <!-- features start -->
      <div class="display-1  text-center mt-5" v-html="$t('content.features_title')"></div>
      <div class="subtitle-1  text-center mb-5 py-5" v-html="$t('content.features_subtitle')"></div>
      <v-row>
        <v-col cols="12" md="4">
          <h2 class="text-center">{{ $t('content.feature1') }}</h2>
          <p class="text-center">{{ $t('content.feature1_details') }}</p>

          <h2 class="text-center">{{ $t('content.feature2') }}</h2>
          <p class="text-center">{{ $t('content.feature2_details') }}</p>

          <h2 class="text-center">{{ $t('content.feature3') }}</h2>
          <p class="text-center">{{ $t('content.feature3_details') }}</p>
        </v-col>
        <v-col cols="12" md="4">
            <v-img
            src="/img/start-features4.png"
            :height="400"
            contain
            ></v-img>
        </v-col>
        <v-col cols="12" md="4">
          <h2 class="text-center">{{ $t('content.feature4') }}</h2>
          <p class="text-center">{{ $t('content.feature4_details') }}</p>

          <h2 class="text-center">{{ $t('content.feature5') }}</h2>
          <p class="text-center">{{ $t('content.feature5_details') }}</p>

          <h2 class="text-center">{{ $t('content.feature6') }}</h2>
          <p class="text-center">{{ $t('content.feature6_details') }}</p>
        </v-col>
      </v-row>
    <!-- features end -->
    </v-container>

    <!--
    Example translated text with variable: {{ $t("user_greeting", { name: "Adam" }) }}<br/>
    -->
  </div>
</template>

<script>

export default {
  name: "home",
  data () {
    return {
      videos: ['01', '002', '05', '06', '08', '09', '110', '002', '111', '113', '114', '115', '116', '117'],
      actVideo: null
    }
  },
  methods: {
    headerVideo () {
      if (this.actVideo == null) this.actVideo = Math.floor(Math.random() * this.videos.length)
      return this.videos[this.actVideo]
    }
  },
  computed: {
    videoSrc () {
      return '//media.polyphonyproject.com/media/frontend/headers/start-page/' + this.headerVideo() + '/video.mp4'
    },
    videoPoster () {
      return '//media.polyphonyproject.com/media/frontend/headers/start-page/' + this.headerVideo() + '/video.jpg'
    },
    videoStyle () {
      var ret = ''
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          ret = 'max-height: 150px; height: 100vh;'; break
        case 'sm':
          ret = 'max-height: 200px; height: 100vh;'; break
        case 'md':
          ret = 'max-height: 400px; height: 100vh;'; break
        case 'lg':
          ret = 'max-height: 600px; height: 100vh;'; break
        case 'xl':
          ret = 'max-height: 600px; height: 100vh;'
      }
      return ret
    }
  }
}
</script>
